import React from 'react';

interface Props {
  title: string;
  error?: string;
  isRequired?: boolean;
  register?: (name: any) => Record<string, unknown>;
  name?: string;
  type?: string;
  defaultValue?: string;
  disabled?: boolean;
}

const required = () => (
  <span
    className="text-danger ms-1"
    style={{
      fontWeight: 'bold',
      fontSize: '1rem',
    }}
  >
    *
  </span>
);

const Input: React.FC<Props> = ({
  title, error, register = () => null, isRequired, name, type = 'text', disabled, defaultValue,
}) => (
  <div className="mb-3 row">
    <label className="col-form-label col-sm-3 text-sm-start">
      {title}
      {isRequired ? required() : null}
    </label>
    <div className="col-sm-9">
      {
        type === 'text-area'
          ? <textarea defaultValue={defaultValue} readOnly={disabled} disabled={disabled} {...register(name)} className={`form-control ${error ? 'is-invalid' : ''}`} autoComplete="new-password" />
          : <input defaultValue={defaultValue} readOnly={disabled} disabled={disabled} type={type} {...register(name)} className={`form-control ${error ? 'is-invalid' : ''}`} autoComplete="new-password" />
      }
      <div className="invalid-feedback">{error}</div>
    </div>
  </div>
);

export default Input;
